// assets/expandable.js

(function () {
  'use strict';

  var appExpandable = {

    target: false,

    lastWidth: window.innerWidth,

    init: function () {
      this.setup();
      this.observe();
    },

    setup: function () {
      // currently empty
    },

    observe: function () {
      var _this = this;

      // Toggle click
      document.addEventListener('click', function (evt) {
        var toggle = evt.target.closest('.js-expandable-toggle');
        if (toggle) {
          if (window.innerWidth < 1024) {
            if (toggle.classList.contains('is-open')) {
              toggle.classList.remove('is-open')
            } else {
              toggle.classList.add('is-open')
            }
            _this.handleToggle(toggle.getAttribute('data-target'));
          }
        }
      });

      // Resize
      window.addEventListener("resize", function () {
        _this.debounce(_this.handleResize(), 250);
      });

    },

    handleResize: function() {
      var _this = this;
      if (window.innerWidth !== this.lastWidth) {
        this.lastWidth = window.innerWidth;
        const expandables = document.getElementsByClassName('js-expandable-section');

        Array.prototype.forEach.call(expandables, function(el, index, array){                
            if (window.innerWidth >= 1024) {
                _this.toggleOn(el, false);            
            } else {
                _this.toggleOff(el);
            }
        });
      }
    },


    debounce: function(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },

    handleToggle: function (id) {
      if (!id) return;

      var expandable = document.querySelector('.js-expandable-section[data-section="' + id + '"]');

      if (expandable) {
        if (expandable.classList.contains('js-expandable-hidden')) {
          this.toggleOn(expandable, true);
        } else {
          this.toggleOff(expandable);
        }
      }
    },

    toggleOn: function (el, animate) {
      let animationSpeed = 300;

      if (!animate) {
        animationSpeed = 0;
      }
        el.classList.remove('js-expandable-hidden')
        el.style.removeProperty('display'); // reset display

        let display = window.getComputedStyle(el).display;
        if (display === 'none') display = 'block';
        el.style.display = display;

        let height = el.scrollHeight;

        el.style.overflow = 'hidden';
        el.style.height = '0px';
        el.offsetHeight; // force repaint

        el.style.transition = `height ${animationSpeed}ms ease`;
        el.style.height = height + 'px';

        window.setTimeout(() => {
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            el.style.removeProperty('transition');
        }, animationSpeed);
    },

    toggleOff: function (el) {
        el.classList.add('js-expandable-hidden')
        el.style.height = el.scrollHeight + 'px';
        el.style.overflow = 'hidden';
        el.offsetHeight; // force repaint

        el.style.transition = `height ${300}ms ease`;
        el.style.height = '0px';

        window.setTimeout(() => {
            el.style.display = 'none';
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            el.style.removeProperty('transition');
        }, 300);
    },

  };

  // Fire after DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    appExpandable.init();
  });

})();
